export default __webpack_public_path__ + "assets/10a88a1db80bd11b98e95897ca3a534a.png";